import moment from "moment-timezone";
import { CoordinatorTimeOff } from "intake_shared/src/assignment";

export function validTimeOffRange(start: string, end: string): boolean {
    return (
        moment(start, "YYYY-MM-DD", true).isValid() &&
        moment(end, "YYYY-MM-DD", true).isValid() &&
        start <= end
    );
}

export function timeOffDays(
    ranges: Pick<CoordinatorTimeOff, "start" | "end">[],
    start: string,
    end: string
): number {
    const days = new Set<string>();
    for (const range of ranges) {
        if (!validTimeOffRange(range.start, range.end)) continue;
        const first = range.start > start ? range.start : start;
        const last = range.end < end ? range.end : end;
        const day = moment.utc(first, "YYYY-MM-DD", true);
        while (day.format("YYYY-MM-DD") <= last) {
            days.add(day.format("YYYY-MM-DD"));
            day.add(1, "day");
        }
    }
    return days.size;
}

export function assignmentEventDate(value: unknown): Date | undefined {
    if (value instanceof Date) return value;
    if (value && typeof (value as { toDate?: unknown }).toDate === "function") {
        return (value as { toDate(): Date }).toDate();
    }
    return undefined;
}
